import React from 'react'
import { loginRequest } from '../msalConfiguration'
import {useMsal} from '@azure/msal-react';

export default function SAML() {
    const { instance } = useMsal();

    function handleLogin() {
        instance.loginRedirect(loginRequest)
        .catch(e => {
            console.error(e);
        });
    }
    return  <button type="button" onClick={handleLogin} className="btn btn-lg btn-primary my-5">Single Sing-on</button>
}
